import {Button, Stack, Typography} from '@mui/material';
import {IconIllustration, Modal} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {DiscardChangesModalProps} from './types';

const {title, subtitle, description} =
	translations['pt-br'].privateFlow.profile.changeData.discardChangesModal;

const {cancel, confirm} = translations['pt-br'].commons;

const DiscardChangesModal = ({open, setOpen, onConfirm}: DiscardChangesModalProps) => (
	<Modal.Root open={open} onClose={() => setOpen(false)}>
		<Modal.Header onClose={() => setOpen(false)} title={title} />

		<Modal.Content>
			<Stack spacing={2} alignItems="center">
				<IconIllustration variant="primary" />
				<Typography variant="h6">{subtitle}</Typography>
				<Typography textAlign="center" variant="body1">
					{description}
				</Typography>
			</Stack>
		</Modal.Content>

		<Modal.Footer>
			<Stack width="100%" direction="row" spacing={1}>
				<Button fullWidth size="large" variant="outlined" onClick={() => setOpen(false)}>
					{cancel}
				</Button>
				<Button
					onClick={onConfirm}
					fullWidth
					size="large"
					variant="contained"
					endIcon={<Icon name="success" />}>
					{confirm}
				</Button>
			</Stack>
		</Modal.Footer>
	</Modal.Root>
);

export {DiscardChangesModal};
